const errorHandler = (response, data, clearSession, history, showToast) => {
    //un authenticated error
    switch (response.status) {
        case 401:
            showToast('error', data.status ? data.status : "Not authenticated", 401)
            clearSession()
            history.push('/login')
            break
        case 403:
            showToast('error', 'Unauthorized Action', 403)
            history.push('/403')
            break
        case 409:
            showToast('error', 'Email already in use. Please use different email!', 409)
            break
        case 500:
            showToast('error', 'Internal Server Error', 500)
            history.push('/500')
            break
        default:
            showToast('error', 'page not found', 404)
            history.push('/404')
            break;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default { errorHandler: errorHandler }